/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Confirm_ReturnInputs */

const vi_order_action_confirm_return = /** @type {(inputs: Order_Action_Confirm_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận hoàn trả`)
};

/**

* @param {Order_Action_Confirm_ReturnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_confirm_return = /** @type {((inputs?: Order_Action_Confirm_ReturnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Confirm_ReturnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_confirm_return(inputs)
});